import HundredBricksAPIError from '../../HundredBricksAPIError';
class PetitionerError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PetitionerError', ...args);
    }
}
export default PetitionerError;
